import _ from 'lodash';
import * as types from '../actions/actionTypes';
import initialState from './initialState';


const getAllPermissions = permissions => {
  const allPermissions = [];
  const allModules = [];
  if (permissions) {
    _.map(permissions, modules => {
      allModules.push(modules.moduleId);
      _.map(modules.permissions, permission => {
        allPermissions.push(permission.id);
      });
    });
  }
  const obj = { features: allPermissions, modules: allModules };
  return obj;
};

export default (state = initialState.userDetails, action) => {
  switch (action.type) {
    case types.GET_CHALLENGE_QUESTION:
      return { ...state, challengeQuestion: action.payload };
    case types.SET_CHALLENGE_QUESTION:
      return { ...state, setChallengeQuestionResponse: action.payload };
    case types.SEND_TEMP_CREDENTIALS:
      return { ...state, sendTmpCredsResponse: action.payload };
    case types.GET_USER_DETAILS:
      return {
        ...state,
        permissions: getAllPermissions(action.payload).features,
        modules: getAllPermissions(action.payload).modules,
        allFeatures: action.allFeatures,
      };
    default:
      return state;
  }
}

